import React from 'react'
import styled from '@emotion/styled'
import { DialogBody, space } from '@ticketswap/solar'
import EmailSent from '../EmailSentIllustration'

const Container = styled.div`
  text-align: center;
`

const Illustration = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${space[32]};
`

class NegativeConfirm extends React.Component {
  timeout = null
  delay = 4000

  componentDidMount() {
    this.timeout = setTimeout(this.props.hide, this.delay)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  render() {
    const { t } = this.props

    return (
      <DialogBody>
        <Illustration>
          <EmailSent />
        </Illustration>
        <Container>
          <p>{t('common:feedbackDialog.confirm.text.negative')}</p>
        </Container>
      </DialogBody>
    )
  }
}

export default NegativeConfirm
